import CryptoJS from 'crypto-js';
import dayjs from 'dayjs';
import _ from 'lodash';

export const encrypt = (text, secret) => {
    const encryptData = CryptoJS.AES.encrypt(JSON.stringify(text), secret).toString();
    return encryptData;
};

export const decrypt = (ciphertext, secret) => {
    var bytes = CryptoJS.AES.decrypt(ciphertext, secret);
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
};

export const groupByDate = (data) => {
    const date = (data) => dayjs(data.createdAt).format('YYYY-MM-DD');
    const result = _.groupBy(data, date);
    return result;
};
